import React, { useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import AccountDetailsCard from "./card/accountDetailsCard";
import { ReactComponent as AccountIcon } from "../../images/account.svg";

import useWindowSize from "../../hooks/useWindowsSize";
import AccountsList from "../common/accounts-list/accountsList";
import { accountDetailsSelector, getAccountDetailsAccounts } from "../../slices/account-details/accountDetailsSlice";

const AccountDetailsAccounts: React.FC<{}> = () => {
  const dispatch = useDispatch();
  const accountDetailsState = useSelector(accountDetailsSelector);
  const tableRef = useRef<HTMLDivElement>(null);
  const windowWidth = useWindowSize()[0];  

  //eslint-disable-next-line
  const contentWidth = useMemo(() => (tableRef.current && tableRef.current?.offsetWidth), [windowWidth]);

  const onInfiniteScroll = () => {
      if (!accountDetailsState.companyInfo?.accountId) return;
  
      dispatch(getAccountDetailsAccounts(accountDetailsState.companyInfo?.teamId, accountDetailsState.companyInfo?.accountId, accountDetailsState.requestScroll["GET_ACCOUNTS"]?.lastIds));
    }

  return (
    <AccountDetailsCard
      mix="account-details__claims"
      title="Accounts"
      icon={<AccountIcon />}
      scrollable={true}
      contentWidth={contentWidth}
    >
      <div className="account-details__table-wrapper">
        <AccountsList
          ref={tableRef}
          data={accountDetailsState.accounts}
          isLoading={accountDetailsState.request["GET_ACCOUNTS"]?.requestStarted}
          rowHeight={56}
          infiniteScroll={true}
          infiniteScrollLoading={accountDetailsState.request["GET_ACCOUNTS_PORTION"]?.requestStarted}
          infiniteScrollHasNext={!accountDetailsState.requestScroll["GET_ACCOUNTS"]?.loadedAll}
          onInfiniteScroll={onInfiniteScroll}
          hideActions
        />
      </div>
    </AccountDetailsCard>
  );
};

export default AccountDetailsAccounts;